<template>
    <header>
        <nav class="container">
            <div class="branding">
                <router-link class="header" :to="`/${$i18n.locale}/`">
                    <img class="band-navbar" src="../assets/navbarImages/band.jpg"/>
                    <img class="brand-logo" alt="salia-wappen" src="../assets/navbarImages/salia-wappen.png"/>
                    Salia-Silesia
                </router-link>
            </div>
            <div class="nav-links">
                <ul v-show="!mobile">
                    <router-link class="link" :to="`/${$i18n.locale}/`">{{ $t('navigation.home') }}</router-link>
                    <router-link class="link" :to="`/${$i18n.locale}/program`">{{ $t('navigation.program') }}</router-link>
                    <div class="dropdown-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
                        <span class="link dropdown-trigger new-posts-highlight">{{ $t('navigation.posts').toUpperCase() }}</span>
                        <div class="dropdown-menu" :class="{ 'show': showDropdown }">
                            <router-link class="dropdown-item" :to="`/${$i18n.locale}/posts`">{{ $t('navigation.posts').toUpperCase() }}</router-link>
                            <router-link class="dropdown-item" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: zimmerFreiBlogId } }">{{ $t('navigation.zimmerFrei').toUpperCase() }}</router-link>
                            <router-link class="dropdown-item" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: aboutUsBlogId } }">{{ $t('navigation.aboutUs').toUpperCase() }}</router-link>
                            <router-link class="dropdown-item" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: geschichteBlogId } }">{{ $t('navigation.geschichte').toUpperCase() }}</router-link>
                        </div>
                    </div>
                    <router-link class="link" :to="`/${$i18n.locale}/contact`">{{ $t('navigation.kontakt') }}</router-link>
                    <language-switcher class="lang-dropdown"></language-switcher>
                </ul>
            </div>
        </nav>
        <menuIcon @click="toggleMobileNav" v-on-clickaway="handleClickAway" class="menu-icon" v-show="mobile"/>
        <transition name="mobile-nav">
            <ul class="mobile-nav" v-show="mobileNav">
                <img class="brand-logo-mobile" alt="salia-wappen" src="../assets/navbarImages/salia-wappen.png"/>
                <router-link class="link link-light" :to="`/${$i18n.locale}/`">{{ $t('navigation.home') }}</router-link>
                <router-link class="link link-light" :to="`/${$i18n.locale}/program`">{{ $t('navigation.program') }}</router-link>
                <span class="link link-light mobile-dropdown-header new-posts-highlight-mobile" @click="handleMobileBeitrageClick" :class="{ 'active': mobileDropdownOpen }">
                    {{ $t('navigation.posts').toUpperCase() }}
                    <span class="dropdown-arrow" :class="{ 'rotated': mobileDropdownOpen }">▼</span>
                </span>
                <div class="mobile-dropdown-items" :class="{ 'open': mobileDropdownOpen }">
                    <router-link class="link link-light mobile-dropdown-item" :to="`/${$i18n.locale}/posts`">{{ $t('navigation.allPosts').toUpperCase() }}</router-link>
                    <router-link class="link link-light mobile-dropdown-item" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: zimmerFreiBlogId } }">{{ $t('navigation.zimmerFrei').toUpperCase() }}</router-link>
                    <router-link class="link link-light mobile-dropdown-item" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: aboutUsBlogId } }">{{ $t('navigation.aboutUs').toUpperCase() }}</router-link>
                    <router-link class="link link-light mobile-dropdown-item" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: geschichteBlogId } }">{{ $t('navigation.geschichte').toUpperCase() }}</router-link>
                </div>
                <router-link class="link link-light" :to="`/${$i18n.locale}/contact`">{{ $t('navigation.kontakt') }}</router-link>
                <br>
                <language-switcher class="lang-dropdown"></language-switcher>
            </ul>
        </transition>
    </header>
</template>

<script>
import menuIcon from '../assets/Icons/bars-regular.svg';
import LanguageSwitcher from './LanguageSwitcher.vue';
import { mixin as clickaway } from 'vue-clickaway';


export default {
    name: 'navigation',
    mixins: [ clickaway ],
    components: {
        menuIcon,
        LanguageSwitcher,
    },
    data() {
        return {
            mobile: null,
            mobileNav: null,
            windowWidth: null,
            showDropdown: false,
            mobileDropdownOpen: false,
        };
    },
    computed: {
        zimmerFreiBlogId() {
            const zimmerFreiPost = this.$store.state.blogPostArray.find(post => post.zimmerFrei);
            return zimmerFreiPost ? zimmerFreiPost.blogID : 6; // fallback to 6 if not found
        },
        aboutUsBlogId() {
            const aboutUsPost = this.$store.state.blogPostArray.find(post => post.aboutUs);
            return aboutUsPost ? aboutUsPost.blogID : 1; // fallback to 1 if not found
        },
        geschichteBlogId() {
            const geschichtePost = this.$store.state.blogPostArray.find(post => post.history);
            return geschichtePost ? geschichtePost.blogID : 4; // fallback to 4 if not found
        }
    },
    created() {
        window.addEventListener('resize', this.checkScreenWidth);
        this.checkScreenWidth();
    },
    methods: {
        checkScreenWidth() {
            this.windowWidth = window.innerWidth;
            if (this.windowWidth <= 1400) {
                this.mobile = true;
                return;
            }
            this.mobile = false;
            this.mobileNav = false;
            return;
        },

        toggleMobileNav() {
            this.mobileNav = !this.mobileNav;
            // Reset dropdown state when opening mobile menu
            if (this.mobileNav) {
                this.mobileDropdownOpen = false;
            }
        },

        disableMobileNav() {
            this.mobileNav = false;
        },

        toggleMobileDropdown() {
            this.mobileDropdownOpen = !this.mobileDropdownOpen;
        },

        handleMobileBeitrageClick() {
            // Only toggle dropdown, don't navigate
            this.toggleMobileDropdown();
        },

        handleClickAway(event) {
            // Don't close menu if clicking on the BEITRÄGE header only
            if (event.target.closest('.mobile-dropdown-header')) {
                return;
            }
            this.disableMobileNav();
        },
    }
};
</script>

<style lang="scss" scoped>
header {
    background-color: #fff;
    padding: 0 25px;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);
    z-index: 99;
    position: sticky;

    .link {
        font-weight: 500;
        padding: 0 25px;
        transition: .3s color ease;
        padding-bottom: 8px;
        font-size: 16px;

        @media(min-width: 1600px) {
            font-size: 20px;
            padding: 0 30px;
        }

        @media(min-width: 2000px) {
            font-size: 24px;
            padding: 0 35px;
        }

        @media(min-width: 2560px) {
            font-size: 28px;
            padding: 0 40px;
        }

        &:hover {
            color: orange;
            border-bottom: groove orange 8px;
            transition: .3s border-bottom ease;
        }
    }


    nav {
        display: flex;
        padding: 25px 0;

        .branding {
            display: flex;
            align-items: center;
        
            .header {
                font-weight: 900;
                font-size: 20px;
                color: #000;
                text-decoration: none;

                @media(min-width: 1600px) {
                    font-size: 26px;
                }

                @media(min-width: 2000px) {
                    font-size: 32px;
                }

                @media(min-width: 2560px) {
                    font-size: 38px;
                }
            }
        }



        .nav-links {
        position: relative;
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: flex-end;

        ul {
            margin-top: 15px;
            margin-right: 24px;

            .link {
                margin-right: 24px;
            }

            .link:last-child {
                margin-right: 0;
            }

            .dropdown-container {
                position: relative;
                display: inline-block;
                margin-right: 24px;

                .dropdown-trigger {
                    cursor: pointer;
                    margin-right: 0;
                    font-weight: 500;
                    padding: 0 25px;
                    padding-bottom: 8px;
                    background-color: #fff;
                    transition: .3s color ease;
                    font-size: 16px;

                    @media(min-width: 1600px) {
                        font-size: 20px;
                        padding: 0 30px;
                    }

                    @media(min-width: 2000px) {
                        font-size: 24px;
                        padding: 0 35px;
                    }

                    @media(min-width: 2560px) {
                        font-size: 28px;
                        padding: 0 40px;
                    }

                    &:hover {
                        color: orange;
                        border-bottom: groove orange 8px;
                        transition: .3s border-bottom ease;
                    }
                }

                &:hover .dropdown-trigger {
                    background-color: #fff;
                    opacity: 0;
                }

                .dropdown-menu {
                    position: absolute;
                    top: -16px;
                    left: -1px;
                    background-color: #fff;
                    border: 1px solid #fff;
                    padding: 15px 0 15px 0;
                    min-width: 160px;
                    max-height: 60px;
                    overflow: hidden;
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity 0.3s ease, visibility 0.3s ease, max-height 0.4s ease;
                    z-index: 1000;

                    .dropdown-item {
                        display: block;
                        padding: 0 25px;
                        padding-bottom: 8px;
                        margin-bottom: 15px;
                        color: #000;
                        text-decoration: none;
                        white-space: nowrap;
                        font-weight: 500;
                        transition: .3s color ease;
                        font-size: 16px;

                        @media(min-width: 1600px) {
                            font-size: 20px;
                            padding: 0 30px;
                        }

                        @media(min-width: 2000px) {
                            font-size: 24px;
                            padding: 0 35px;
                        }

                        @media(min-width: 2560px) {
                            font-size: 28px;
                            padding: 0 40px;
                        }

                        &:hover {
                            color: orange;
                            border-bottom: groove orange 8px;
                            background-color: #fff;
                            transition: .3s border-bottom ease;
                        }

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }

                .dropdown-menu.show {
                    opacity: 1;
                    visibility: visible;
                    max-height: 300px;
                }
            }
        }

    }

    // Special styling for new posts highlight
    .new-posts-highlight {
        color: darkorange !important;
        font-weight: 600 !important;

        &:hover {
            color: black !important;
            border-bottom: groove darkorange 8px !important;
        }
    }
    }

    .menu-icon {
        cursor: pointer;
        position: absolute;
        top: 50px;
        right: 25px;
        height: 25px;
        width: auto;
    }

    .brand-logo {
        cursor: pointer;
        flex: 1;
        position: relative;
        left: -10px;
        top: -5px;
        height: 80px;
        width: auto;
        margin-right: 20px;
    }

    .brand-logo-mobile {
        height: 80px;
        width: 80px;
        transform: translate(80%, 0%);
        margin-bottom: 20px;
    }

    .band-navbar {
        width: 100%;
        height: 20px;
        left: 0;
        top: 110px;
        position: absolute;        
    }

    .mobile-nav {
        text-align: center;
        padding: 20px;
        width: 70%;
        max-width: 250px;
        display: flex;
        flex-direction: column;
        position: fixed;
        height: 100%;
        background-color: #303030;
        top: 0;
        left: 0;
        z-index: 200;

        .link {
            padding: 15px 0;
            color: #fff;

            &:hover {
                color: orange;
            }
        }

        .mobile-dropdown-header {
            font-weight: 500;
            padding: 15px 0;
            cursor: pointer;
            text-align: center;
            position: relative;

            &.active {
                color: orange;

                .dropdown-arrow {
                    color: orange;
                }
            }

            .dropdown-arrow {
                color: #fff;
                font-size: 0.8em;
                position: absolute;
                left: calc(50% + 65px);
                top: 50%;
                transform: translateY(-50%);
                transition: transform 0.3s ease, color 0.3s ease;

                &.rotated {
                    transform: translateY(-50%) rotate(180deg);
                }
            }
        }

        .mobile-dropdown-items {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.4s ease;
            display: flex;
            flex-direction: column;

            &.open {
                max-height: 250px;
                overflow-y: auto;
                overflow-x: hidden;

                // Custom scrollbar styling to match dark menu theme
                &::-webkit-scrollbar {
                    width: 8px;
                }

                &::-webkit-scrollbar-track {
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 4px;
                }

                &::-webkit-scrollbar-thumb {
                    background: rgba(255, 255, 255, 0.3);
                    border-radius: 4px;

                    &:hover {
                        background: rgba(255, 165, 0, 0.7); // Orange on hover
                    }
                }

                // Firefox scrollbar styling
                scrollbar-width: thin;
                scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);
            }
        }

        .mobile-dropdown-item {
            padding: 15px 0;
            font-size: 0.8em;
            display: block;
            width: 100%;
        }

        // Special styling for mobile new posts highlight
        .new-posts-highlight-mobile {
            color: darkorange !important;
            font-weight: 600 !important;

            &:hover, &.active {
                color: black !important;

                .dropdown-arrow {
                    color: black !important;
                }
            }
        }
    }

  .mobile-nav-enter-active,
  .mobile-nav-leave-active {
    transition: all 0.75s ease;
  }

  .mobile-nav-enter {
    transform: translateX(-250px);
  }

  .mobile-nav-enter-to {
    transform: translateX(0);
  }

  .mobile-nav-leave-to {
    transform: translateX(-250px);
  }
}

</style>